// Import model
import { CatalogFeed } from '../models/CatalogFeed';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CatalogFeed - handles JSON serialization and deserialization with type validation
 */
export class CatalogFeedSerializer {
  /**
   * Deserializes a JSON string into a CatalogFeed instance
   */
  static deserialize(json: string): CatalogFeed {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CatalogFeed instance
   */
  static fromObject(obj: any): CatalogFeed {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CatalogFeed');
    }


    const instance: CatalogFeed = {
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      isActive: obj['IsActive'] as boolean | undefined,
      id: obj['_id'] as string | undefined,
      t: obj['_t'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CatalogFeed instances
   */
  static deserializeArray(json: string): CatalogFeed[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CatalogFeed instance to a JSON string
   */
  static serialize(instance: CatalogFeed): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CatalogFeed instance to a plain object
   */
  static toObject(instance: CatalogFeed): any {
    return {
      'Name': instance.name,
      'Description': instance.description,
      'IsActive': instance.isActive,
      '_id': instance.id,
      '_t': instance.t,
    };
  }

  /**
   * Serializes an array of CatalogFeed instances to a JSON string
   */
  static serializeArray(instances: CatalogFeed[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
